<template>
  <div id="app">
    <AppHeader />
    <div class="lang-corner">
      <AppLangNav />
    </div>
    <div class="content-main">
      <router-view />
    </div>
    <AppFooter />
  </div>
</template>

<script>
import AppLangNav from '@/components/app/AppLangNav.vue';
import AppFooter from '@/components/app/AppFooter.vue';
import AppHeader from '@/components/app/AppHeader.vue';

import './assets/css/bootstrap.scss';
import 'gedepiar/dist/gedepiar.css';
import Gedepiar from 'gedepiar';

export default {
  components: {
    AppLangNav,
    AppFooter,
    AppHeader,
  },
  watch: {
    '$i18n.locale': function setLang(locale) {
      document.documentElement.lang = locale;
    },
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has('lang')) {
      this.$i18n.locale = urlParams.get('lang');
    }

    document.documentElement.lang = this.$i18n.locale;

    Gedepiar.init({
      services: ['ga'],
      fallbackLang: 'en',
    });
  },
};
</script>

<style lang="scss">
  /*html {
    font-size:62.5%;
  }*/

  .lang-corner {
    position: fixed;
    top: 0;
    right: 1.25rem;
    z-index: 1000;
    background: #1e1e1e;
    padding: 0.6rem 0.75rem;
    border-radius: 0 0 8px 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  }

  body {
    background:url('./assets/img/bg_pattern.jpg');
  }

  h3 {
    font-weight:bold;
  }

  img {
    max-width:100%;
  }

  .contentbox {
    background:#fff;
    padding:1.5rem;
  }

  /* Forms */
  .panel {
    margin:0 0 1.5rem;

    &.has-bg {
      background:$gray-200;
      padding:1.5rem;
    }
  }

  .btn-primary {
    color:#fff;
  }

  label,
  h3 {
    .btn{
      color:$primary;
      padding:0 0.5rem;
      line-height: 1;

      &:hover {
        color: darken($primary, 15%);
      }
    }
  }
  th {
    white-space: nowrap;
  }
  td {
    white-space: nowrap;
    .btn-link {
      color:$primary;
      padding:0 0.5rem;
      line-height: 1;
      &:hover {
        color: darken($primary, 15%);
      }
    }
  }
  .alert {
    ul {
      margin:0;
      padding:0 0 0 1rem;
    }
  }

  :root {
    --gedepiar-color-primary: #{$primary};
  }
</style>
